import React, { useCallback, useEffect, useState } from "react";
import { Spin, Tooltip, notification } from "antd";
import "./expandableTable.scss";
import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import TableWithDynamicPagination from "../../table/table";
import WellBeEMPIService from "@services/empiService.service";
import { map, sortBy, filter, isEmpty } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
import Icon from "@assets/icon_config";
import SearchRecords from "../searchReacordsTable/searchRecordsTable";
import ExtraDetailsOfUser from "../detailsOfUser/detailsOfUser";
import MatchedRecords from "../matchingRecordsTable/matchingRecordsTable";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { formatDisplayDate } from "@utils/helpers";

const ExpandableTable = (props: { payer: any; activeTab: any }) => {
  const [columnList, setColumnList] = useState<any>([]);
  const [pendingUniqueIds, setPendingUniqueIds] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false); // this state is specifically for merge and create. Don't use it for any other loading.
  const [columnsNeedToShowInTable, setColumnsNeedToShowInTable] = useState<any>([]);
  const [columnsNeedToShowInPopUp, setColumnsNeedToShowInPopUp] = useState<any>([]);

  // states related to search Pop up.
  const [columnsNeedToShowInSearchTable, setColumnsNeedToShowInSearchTable] = useState<any>([]);
  const [columnsNeedToShowInSearchPopUp, setColumnsNeedToShowInSearchPopUp] = useState<any>([]);

  const fetchData = async (payload: any) => {
    console.log("ExpandableTable.fetchData.getEmpiRecordsForInterventionCases");
    setPendingUniqueIds([]);
    const _data = await axios.post(`${sessionService.getClient()?.appServiceUrl}/empi/intervention-cases`, { ...payload, payerName: props.payer }).then((response) => {
      return response.data.data.records;
    });
    return { totalCount: _data?.count, data: _data?.empiRecords };
  };

  const handlePlusClick = useCallback(
    ({ uniqueId }: any) => {
      setIsLoading(true);
      WellBeEMPIService.createNewEmpi({
        sourceId: uniqueId,
        targetId: null,
        action: "create",
      }).subscribe({
        next: (v) => {
          setPendingUniqueIds([...pendingUniqueIds, uniqueId]);
          notification.success({
            message: "New EMPI is under process",
            description: "New EMPI is under process & the record will be moved to EPMI Master after processing.",
            placement: "top",
            className: "greenNotification",
          });
          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setIsLoading(false);
        },
      });
    },
    [pendingUniqueIds]
  );

  const handleMergeClick = useCallback(
    ({ uniqueId, targetId }: any) => {
      setIsLoading(true);
      WellBeEMPIService.createNewEmpi({
        sourceId: uniqueId,
        targetId: targetId,
        action: "merge",
      }).subscribe({
        next: (v) => {
          setPendingUniqueIds([...pendingUniqueIds, uniqueId]);
          notification.success({
            message: "Record Being Assigned to Selected EMPI",
            description: "Record has been Assigned to the Selected EMPI ID and the Data has moved to Pending Processing.",
            placement: "top",
            className: "greenNotification",
          });
          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setIsLoading(false);
        },
      });
    },
    [pendingUniqueIds]
  );

  useEffect(() => {
    let _columns = map(columnsNeedToShowInTable, (item) => {
      if (item.key === "pred_empi_confdc_score") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          sorter: true,
          render: (value: any, record: any) => {
            return (
              <div className="ui-expandable-table__empi-match-column">
                <div className="ui-expandable-table__empi-match-column__value">{value}% Match</div>
                {/* if records is in pending state don't show matching records icons */}
                {/* {!record?.isPendingProcessing && !pendingUniqueIds.includes(record?.member_unique_id) && (
                  <MatchedRecords
                    record={record}
                    columnsNeedToShowInTable={columnsNeedToShowInTable}
                    payer={props.payer}
                    columnsNeedToShowInPopUp={columnsNeedToShowInPopUp}
                    isLoading={isLoading}
                    icon={<Icon name="lesserThanGreaterThanArrow" />}
                    handleMergeClick={handleMergeClick}
                  />
                )} */}
              </div>
            );
          },
        };
      } else if (item.key === "action_desc") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,

          render: (value: any, record: any) => {
            //  if records is in pending state don't show matching records and other icons
            return record?.isPendingProcessing || pendingUniqueIds.includes(record?.member_unique_id) ? (
              <div className="ui-expandable-table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={columnsNeedToShowInPopUp} />
              </div>
            ) : (
              <div className="ui-expandable-table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={columnsNeedToShowInPopUp} />
                <MatchedRecords
                  handleMergeClick={handleMergeClick}
                  record={record}
                  columnsNeedToShowInTable={columnsNeedToShowInTable}
                  payer={props.payer}
                  columnsNeedToShowInPopUp={columnsNeedToShowInPopUp}
                  isLoading={isLoading}
                />
                <SearchRecords
                  columnsNeedToShowInSearchTable={columnsNeedToShowInSearchTable}
                  columnsNeedToShowInSearchPopUp={columnsNeedToShowInSearchPopUp}
                  handleMergeClick={handleMergeClick}
                  record={record}
                  payer={props.payer}
                  isLoading={isLoading}
                  uniqueId={record?.member_unique_id} key={record?.member_unique_id}
                />
                <Tooltip placement="left" title="Merge Into Highest Matching Patient">
                  <CheckOutlined
                    onClick={() => {
                      handleMergeClick({ uniqueId: record?.member_unique_id, targetId: record?.highestMatchingRecord?.member_unique_id });
                    }}
                  />
                </Tooltip>
                <Tooltip title="Create New EMPI">
                  <PlusOutlined
                    title="Create New EMPI"
                    onClick={() => {
                      handlePlusClick({ uniqueId: record?.member_unique_id });
                    }}
                  />
                </Tooltip>
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else {
        return { title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, sorter: true, render: (value: any) => value || "--" };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    setColumnList(_columns);
  }, [handleMergeClick, handlePlusClick, pendingUniqueIds, props.payer, columnsNeedToShowInTable, columnsNeedToShowInPopUp, isLoading, columnsNeedToShowInSearchTable, columnsNeedToShowInSearchPopUp]);

  useEffect(() => {
    WellBeEMPIService.getColumnsList({ pageName: "EMPI-Stewardship-Intervention-Cases" }).subscribe({
      next: (v) => {
        setColumnsNeedToShowInTable(
          filter(v.data.data.columns, (item) => {
            return item.isDisplay === "Y";
          })
        );
        setColumnsNeedToShowInPopUp(
          filter(v.data.data.columns, (item) => {
            return item.isAdditionalInfo === "Y";
          })
        );
        // Api Call for the search Pop Up
        WellBeEMPIService.getColumnsList({ pageName: "EMPI-Stewardship-Intervention-Cases-Search" }).subscribe({
          next: (v) => {
            setColumnsNeedToShowInSearchTable(
              filter(v.data.data.columns, (item) => {
                return item.isDisplay === "Y";
              })
            );
            setColumnsNeedToShowInSearchPopUp(
              filter(v.data.data.columns, (item) => {
                return item.isAdditionalInfo === "Y";
              })
            );
          },
          error: (e) => {
            console.log(e);
          },
        });
      },
      error: (e) => {
        console.log(e);
      },
    });
  }, []);

  return (
    <Spin spinning={isLoading} indicator={<HealthemSpinner />}>
      <TableWithDynamicPagination
        dependencyProps={[props.payer, props.activeTab]}
        condition={!isEmpty(props.payer) && props.activeTab === "intervention_cases"}
        className="ui-expandable-table"
        columns={columnList}
        handleFetchData={fetchData}
        rowSelectionNeeded={false}
        perPageCount={10}
        columnOriginalList={columnsNeedToShowInTable}
      />
    </Spin>
  );
};

export default ExpandableTable;
